// gen
const baseUrl = "https://constvisitor.const.cc/index";
// dev
// const baseUrl = "http://kst.ubooking.cn/index";

export default {
  baseUrl
};



// WEBPACK FOOTER //
// ./src/global/constant.js